export enum MarketDataFeedUserTypesEnum {
    Client = 1,
    ClientUser,
    ServiceUser
}
